import { createAction } from "redux-actions";
import { GET_PERIODS_CORE } from "../constants";
import { feathersCreateData } from "../services";

export const getPeriodsCore = createAction(GET_PERIODS_CORE, () => feathersCreateData('core-server', {
    service: 'COLLECTIONS',
    func: 'GET_SCHOOL_YEARS'
})())